import React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

/**
 * A component that renders a drop-down selector for a list of poems.
 *
 * @param {{ poems: Array<{ title: string, author: string }>, selectedPoemIndex: number, onSelectPoem: Function }} props
 *   - poems: List of poems to present in the selector.
 *   - selectedPoemIndex: Index of the poem that is currently selected (or null if none).
 *   - onSelectPoem: Callback function to invoke when a poem is selected.
 * @returns {React.ReactElement} A JSX element representing the poem selector.
 */
const PoemSelector = React.memo(function PoemSelector({ poems, selectedPoemIndex, onSelectPoem }) {
  //log what triggered the component so we can trace back to the source
  console.log('[PoemSelector] Rendered with props:', {
    poems,
    selectedPoemIndex,
    onSelectPoem,
  });

  if (!poems || poems.length === 0) return null;
  return (
    <Box>
      <Select
        fullWidth
        value={selectedPoemIndex ?? ''}
        displayEmpty
        onChange={e => onSelectPoem(Number(e.target.value))}
        size="small"
        sx={{
          fontSize: '0.75rem',
          minHeight: 24,
          height: 24,
          '& .MuiSelect-select, & .MuiInputBase-input': {
            minHeight: 'unset !important',
            paddingTop: '4px',
            paddingBottom: '4px',
            fontSize: '0.85rem',
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: { fontSize: '0.75rem' },
          },
        }}
      >
        <MenuItem value="" sx={{ fontSize: '0.85rem', mb: 0 }}>
          -- Choose a poem --
        </MenuItem>
        {poems.map((poem, idx) => (
          <MenuItem key={idx} value={idx} sx={{ fontSize: '0.75rem' }}>
            {poem.title} — {poem.author}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
});

export default PoemSelector;